import { ButtonUpdate } from '../../Form/Buttons/ButtonUpdate';
import { FormDelete } from '../../Form/FormDelete.js';

export const ListDefault = (props) => {
    const { entity, datas } = props;
    return (
        <div className="admin-list">
            <div className="title">
                <div>{`ADMIN: ${entity} (${datas.length})`}</div>
            </div>
            <div className="thead">
                <div className="block-rows">
                    <div className="id">id</div>
                    <div className="name">name</div>
                </div>
                <div className="block-buttons"></div>
            </div>
            {datas.map((el, i) => {
                return (
                    <div key={i} className="rows">
                        <div className="block-rows">
                            <div className="id">{el.id}</div>
                            <div className="item">{el.name}</div>
                        </div>
                        <div className="block-buttons">
                            <ButtonUpdate entity={entity} id={el.id} />
                            <FormDelete entity={entity} id={el.id} />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}